import { Message } from "./types";

export const ALLOWED_EXTENSIONS = [
  "pdf",
  "png",
  "jpg",
  "jpeg",
  "webp",
  "svg",
  "bmp",
  "ico",
];

export const GREETING_MESSAGE: Message = {
  role: "assistant",
  text: "-Hi, how can I help you today?",
  timeStamp: null,
};

export const ASSISTANT_MESSAGE_CLASSES = [
  "tw-w-fit",
  "tw-max-w-3xl",
  "tw-p-4",
  "tw-rounded",
  "[&_h1]:tw-text-xl",
  "[&_h2]:tw-text-lg",
  "[&_h3]:tw-text-md",
  "[&_h1]:tw-mx-0",
  "[&_h2]:tw-mx-0",
  "[&_h3]:tw-mx-0",
  "[&_h1]:tw-mb-4",
  "[&_h2]:tw-mb-4",
  "[&_h3]:tw-mb-4",
  "[&_h1]:tw-mt-8",
  "[&_h2]:tw-mt-8",
  "[&_h3]:tw-mt-8",
  "[&_p]:tw-mx-0",
  "[&_p]:tw-mt-0",
  "[&_p]:tw-mb-6",
  "[&_ul]:tw-list-disc",
  "[&_ul]:tw-pl-6",
  "[&_li]:tw-mb-6",
  "[&_strong]:tw-font-semibold",
  "[&_code]:tw-transition-opacity",
  "[&_code]:tw-ease-in-out",
  "[&_code]:tw-bg-secondary",
  "[&_code]:tw-opacity-75",
  "[&_code:hover]:tw-opacity-100",
  "[&_code]:tw-text-white",
  "[&_code]:tw-px-1.5",
  "[&_code]:tw-rounded-md",
  "[&>*:first-child]:tw-mt-0",
  "[&>*:last-child]:tw-mb-0",
].join(" ");

export const USER_MESSAGE_CLASSES = [
  "tw-w-fit",
  "tw-max-w-3xl",
  "tw-p-4",
  "tw-rounded",
  "tw-bg-gray-200",
  "[&_p]:tw-mx-0",
  "[&_li]:tw-pb-4",
].join(" ");
